import React, { useState } from "react";
import { useAuthRedirect } from "../../components/utils/hooks";
import "./Devices.css";

function Devices() {
  const { user, loading } = useAuthRedirect();
  const [tabValue, setTabValue] = useState("1");

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  if (loading) {
    return null;
  }

  return (
    <div className="Devices">
      Devices
    </div>
  );
}

export default Devices;